import React, { Component } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { IScatterChartProps } from '../../typings/chart';
import guid from '../../generic/Guid';
import am4themesNoAnimated from '@amcharts/amcharts4/themes/amcharts';
import { debounce } from 'underscore';
import { Loading } from '../Loading/Loading';
import styles from './Chart.module.scss';
import './amchart.css';

am4core.useTheme(am4themesNoAnimated);
// am4core.options.commercialLicense = true;
am4core.options.queue = true;

export default class ScatterChart extends Component<
  IScatterChartProps,
  { loading: boolean }
> {
  amChart!: am4charts.XYChart;
  GUID = guid();
  constructor(props: any) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {
    this.createChart();
    this.createSeries();
    this.updateChartData();
  }

  componentWillUnmount() {
    if (this.amChart) {
      this.amChart.dispose();
    }
  }

  componentDidUpdate(oldProps: IScatterChartProps) {
    if (oldProps.data !== this.props.data) {
      this.updateChartData();
    }
  }

  createChart = () => {
    const chart = am4core.create(this.GUID, am4charts.XYChart);
    chart.cursor = new am4charts.XYCursor();
    chart.zoomOutButton.scale = 0.5;
    const xAxis = chart.xAxes.push(new am4charts.ValueAxis());
    xAxis.renderer.labels.template.fontSize = '10px';
    xAxis.renderer.ticks.template.disabled = true;
    xAxis.renderer.axisFills.template.disabled = true;
    xAxis.title.text = this.props.seriesX.name;

    const yAxis = chart.yAxes.push(new am4charts.ValueAxis());
    yAxis.renderer.minLabelPosition = 0.01;
    yAxis.renderer.labels.template.fontSize = '10px';
    yAxis.renderer.ticks.template.disabled = true;
    yAxis.renderer.axisFills.template.disabled = true;
    yAxis.title.text = this.props.seriesY.name;

    chart.events.on('datavalidated', () => {
      this.setState({ loading: false });
      this.updateSeriesX();
      this.updateSeriesY();
    });
    this.amChart = chart;
  };

  createSeries = () => {
    for (let i = 0; i < 100; i++) {
      const series = this.amChart.series.push(new am4charts.LineSeries());
      series.dataFields.valueX = 'x';
      series.dataFields.valueY = `y${i}`;
      series.strokeWidth = 0;
      // series.minBulletDistance = 5;
      const bullet = series.bullets.push(new am4core.Circle());
      bullet.tooltipText = `x: {valueX} \n y: {valueY}`;
      bullet.radius = 2;
      bullet.strokeWidth = 0;
      bullet.fill = am4core.color('#59d6ff');
    }
  };

  updateSeriesX = () => {
    const xAxis = this.amChart.xAxes.getIndex(0) as am4charts.ValueAxis;
    if (xAxis !== undefined) {
      xAxis!.title.text = this.props.seriesX.name;
      xAxis!.max = this.props.seriesX.max;
      xAxis.invalidate();
    }
  };

  updateSeriesY = () => {
    const yAxis = this.amChart.yAxes.getIndex(0) as am4charts.ValueAxis;
    if (yAxis !== undefined) {
      yAxis!.title.text = this.props.seriesY.name;
      yAxis!.max = this.props.seriesY.max;
      yAxis.invalidate();
    }
  };

  updateChartData = debounce(() => {
    if (this.amChart.data !== this.props.data) {
      this.setState({ loading: true });
      // setTimeout(() => {
      // this.updateSeriesX();
      // this.updateSeriesY();
      this.amChart.data = this.props.data;
      // }, 200);
    }
  }, 50);

  exportChartAsImage = () => {
    this.amChart.exporting.getImage("jpg").then((imgData) => {
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `${this.props.downloadName}.jpg` ?? 'Downloaded Chart'
      link.click();
    });
  };

  render() {
    return (
      <div className={styles.root} id={this.GUID}>
        <Loading loading={this.state.loading}></Loading>
      </div>
    );
  }
}
